<template>
  <div class="container">
    <div class="alert alert-danger" v-if="error" role="alert">
      {{ error }}
    </div>
    <h3>Vill du radera kontakten?</h3>
    <dl>
      <dt>Förnamn</dt>
      <dd>{{ contact.Firstname }}</dd>
      <dt>Efternamn</dt>
      <dd>{{ contact.Lastname }}</dd>
    </dl>
    <button type="button" class="btn btn-link" @click="$router.go(-1)">Avbryt</button>
    <button type="submit" class="btn btn-danger" @click="deleteContact">Radera</button>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  props: ['id'],

  data () {
    return {
      error: '',
      contact: {}
    }
  },

  created () {
    appService.getContact(this.id)
    .then((data) => { this.contact = data })
  },

  methods: {
    deleteContact () {
      appService.deleteContact(this.id)
      .then(() => { this.$router.go(-1) })
      .catch((err) => { this.error = err.response.data })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/ContactDelete.vue